// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__80xEQ","inputWrap":"Table_inputWrap__pEX9D","col":"Table_col__DALyH","bmiTooltip":"Table_bmiTooltip__1pLQj"};